import thunk from "redux-thunk";
import { createStore, applyMiddleware, compose } from "redux";
import rootReducer from "./reducers/rootReducer";
import { normalizeEnabledFeatures } from "../services/utils/featureAccess";

const getStoreInitialState = () => {
  var storeState = {};
  let token = localStorage.getItem("token");
  if (token) {
    let role = localStorage.getItem("role");
    let jobType = localStorage.getItem("jobType");
    let email = localStorage.getItem("email");
    let fullName = localStorage.getItem("fullName");
    let belongToCardNum = localStorage.getItem("belongToCardNum");
    let enabledFeatures = [];
    let licenseNumber = localStorage.getItem("licenseNumber");
    let disableTaxAuthorityDocumentConfirmation = localStorage.getItem("disableTaxAuthorityDocumentConfirmation") === "true";
    let abilities = localStorage.getItem("abilities");
    let areRemindersOn = localStorage.getItem("areRemindersOn") === "true";
    try {
      enabledFeatures = JSON.parse(localStorage.getItem("enabledFeatures") || "[]");
    } catch (e) {
      enabledFeatures = [];
    }
    enabledFeatures = normalizeEnabledFeatures(enabledFeatures);
    if (abilities) abilities = abilities.split(",");
    let softwareServiceType = localStorage.getItem("softwareServiceType");

    storeState["loggedinReducer"] = {
      isLoggedIn: true,
      role,
      jobType,
      belongToCardNum,
      enabledFeatures,
      email,
      fullName,
      licenseNumber,
      disableTaxAuthorityDocumentConfirmation,
      abilities,
      softwareServiceType,
      areRemindersOn
    };
  }

  return storeState;
};

const composeEnhancers = /*process.env.NODE_ENV === "development" ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ : null ||*/ compose;

const store = createStore(rootReducer, getStoreInitialState(), composeEnhancers(applyMiddleware(thunk)));

export default store;
